<template>
<div class="chapter">
<div class="inner_page">
<p class="ttl" id="ch2"><a href="#/Hell_and_Beyond_Split6#toc2"><b>Preface</b></a></p>
<p class="tx1">Readers of C.S. Lewis and George MacDonald, as well as my own <i>The Garden at the Edge of Beyond</i>, will discover in what follows a few similarities with certain of the works of my two literary friends, as well as with my own.</p>
<p class="tx">I have intentionally borrowed these images in order to convey an important truth: as Lewis says in the preface to his classic <i>The Great Divorce</i>, we do not and cannot know what the afterlife holds.</p>
<p class="tx">This being so, it has seemed to me that drawing upon a wide range of what Lewis calls “imaginative supposals” will guard against over-emphasis on any one theme, or imbalance toward error in some other direction. I have thus called upon my two mentors in the Spirit to broaden the base of my own imaginative supposals, as well as add a degree of interest and fun to the attempt.</p>
<p class="tx">As I am certain George MacDonald was delighted to play a pivotal role in Lewis’s imaginative work, I hope they will not mind being pressed into service a second time in mine, as they were in <i>The Garden at the Edge of Beyond</i>. My desire has been neither to copy nor imitate them, but rather in this way to honor their contributions to the important ongoing discussion about what are God’s eternal purposes for his creation.</p>
<p class="tx12">Michael Phillips</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hell_and_Beyond_Split8.vue?266d7b8e